var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "integrations-view" } },
    [
      _c(
        "material-card",
        {
          attrs: { color: "primary", icon: "mdi-toolbox-outline" },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_vm._v(" Integrations ")]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _vm.loading
                ? _c("v-progress-linear", {
                    attrs: { color: "primary", indeterminate: "" }
                  })
                : _c(
                    "v-row",
                    _vm._l(_vm.integrations, function(integration) {
                      return _c(
                        "v-col",
                        {
                          key: integration.slug,
                          attrs: { cols: "12", md: "6", lg: "4" }
                        },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "d-flex flex-column fill-height",
                              attrs: { outlined: "" }
                            },
                            [
                              _c(
                                "v-card-title",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var attrs = ref.attrs
                                              var on = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "mr-3 pa-0",
                                                        attrs: {
                                                          "aria-label":
                                                            "Configure " +
                                                            integration.name,
                                                          "min-width": integration.image
                                                            ? 80
                                                            : 42,
                                                          height: "42",
                                                          text: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openIntegration(
                                                              integration.slug
                                                            )
                                                          }
                                                        }
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    integration.image
                                                      ? _c("v-img", {
                                                          attrs: {
                                                            alt:
                                                              integration.name +
                                                              " logo",
                                                            src:
                                                              integration.image,
                                                            contain: "",
                                                            height: "42",
                                                            width: "80"
                                                          }
                                                        })
                                                      : _c(
                                                          "v-avatar",
                                                          {
                                                            attrs: {
                                                              color: "primary",
                                                              size: "42"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  color: "white"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.default_icon
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Configure " +
                                            _vm._s(integration.name)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" " + _vm._s(integration.name) + " ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                { staticClass: "flex-grow-1" },
                                [
                                  _vm._v(
                                    " " + _vm._s(integration.description) + " "
                                  )
                                ]
                              ),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", text: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.openIntegration(
                                            integration.slug
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-cog")
                                      ]),
                                      _vm._v(" Configure ")
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "900", scrollable: "" },
          model: {
            value: _vm.serviceTitanDialog,
            callback: function($$v) {
              _vm.serviceTitanDialog = $$v
            },
            expression: "serviceTitanDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" Configure ServiceTitan ")]),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "8" } },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "fill-height",
                                        attrs: { outlined: "" }
                                      },
                                      [
                                        _c(
                                          "v-card-title",
                                          { staticClass: "subtitle-1" },
                                          [_vm._v(" Configuration ")]
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-card-text",
                                          [
                                            _c(
                                              "v-row",
                                              { attrs: { dense: "" } },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Tenant ID"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.settings
                                                            .service_titan.id,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.settings
                                                              .service_titan,
                                                            "id",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "settings.service_titan.id"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm.settings.service_titan.id &&
                                                _vm.settings.service_titan
                                                  .integration
                                                  ? [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "Client ID"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .client_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "client_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.client_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label:
                                                                "Client Secret"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .client_secret,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "client_secret",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.client_secret"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label:
                                                                "Default Technician ID"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .technician_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "technician_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.technician_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "Vendor ID"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .vendor_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "vendor_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.vendor_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label: "SKU ID"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .sku_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "sku_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.sku_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label:
                                                                "Order Type ID"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .order_type_id,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "order_type_id",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.order_type_id"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.settings.service_titan
                                                        .app_version === 2
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                md: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Service Category ID"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .settings
                                                                        .service_titan
                                                                        .service_category_id,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .settings
                                                                          .service_titan,
                                                                        "service_category_id",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "settings.service_titan.service_category_id"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.settings.service_titan
                                                        .app_version === 2
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                md: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Pending Approval Delay (hours)"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .settings
                                                                        .service_titan
                                                                        .pending_approval_delay,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .settings
                                                                          .service_titan,
                                                                        "pending_approval_delay",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "settings.service_titan.pending_approval_delay"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.settings.service_titan
                                                        .app_version === 2
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                                md: "6"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      "Pricebook Category ID"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .settings
                                                                        .service_titan
                                                                        .pricebook_category_id,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .settings
                                                                          .service_titan,
                                                                        "pricebook_category_id",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "settings.service_titan.pricebook_category_id"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          attrs: {
                                                            cols: "12",
                                                            md: "6"
                                                          }
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            attrs: {
                                                              label:
                                                                "Notification Alerts Email"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.settings
                                                                  .service_titan
                                                                  .notification_email,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.settings
                                                                    .service_titan,
                                                                  "notification_email",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "settings.service_titan.notification_email"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "4" } },
                                  [
                                    _c(
                                      "v-card",
                                      {
                                        staticClass: "fill-height",
                                        attrs: { outlined: "" }
                                      },
                                      [
                                        _c(
                                          "v-card-title",
                                          { staticClass: "subtitle-1" },
                                          [_vm._v(" Setup Instructions ")]
                                        ),
                                        _c("v-divider"),
                                        _c("v-card-text", [
                                          _c("ol", { staticClass: "pl-4" }, [
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(
                                                " Within your ServiceTitan account, go to "
                                              ),
                                              _c("strong", [
                                                _vm._v("Settings")
                                              ]),
                                              _vm._v(". ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" Under the "),
                                              _c("strong", [
                                                _vm._v("Integrations")
                                              ]),
                                              _vm._v(" tab, select "),
                                              _c("strong", [
                                                _vm._v("API Application Access")
                                              ]),
                                              _vm._v(". ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" After adding your "),
                                              _c("strong", [
                                                _vm._v("Tenant ID")
                                              ]),
                                              _vm._v(
                                                ", please allow up to 24 hours before finishing these instructions. "
                                              )
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" Click "),
                                              _c("strong", [
                                                _vm._v("Connect New App")
                                              ]),
                                              _vm._v(". ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" Select the "),
                                              _c("strong", [
                                                _vm._v("ecDirect - V2")
                                              ]),
                                              _vm._v(" app, then click "),
                                              _c("strong", [_vm._v("Connect")]),
                                              _vm._v(". ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" Click "),
                                              _c("strong", [
                                                _vm._v("Allow Access")
                                              ]),
                                              _vm._v(" in the popup window. ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(
                                                " After the app is connected, you will be directed to the "
                                              ),
                                              _c("strong", [
                                                _vm._v("Application Details")
                                              ]),
                                              _vm._v(" page. ")
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(
                                                " The first two boxes show your "
                                              ),
                                              _c("strong", [
                                                _vm._v("Client ID")
                                              ]),
                                              _vm._v(" and "),
                                              _c("strong", [
                                                _vm._v("Client Secret")
                                              ]),
                                              _vm._v(
                                                ". We need both to complete the integration. "
                                              )
                                            ]),
                                            _c("li", { staticClass: "mb-3" }, [
                                              _vm._v(" Select "),
                                              _c("strong", [_vm._v("Copy")]),
                                              _vm._v(
                                                " next to the Client ID and paste it into this form. "
                                              )
                                            ]),
                                            _c("li", [
                                              _vm._v(" Click "),
                                              _c("strong", [
                                                _vm._v("Generate")
                                              ]),
                                              _vm._v(
                                                " to show your unique Client Secret. "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  "The Client Secret is visible only once"
                                                )
                                              ]),
                                              _vm._v(
                                                ", so copy it and paste it into this form. "
                                              )
                                            ])
                                          ])
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: !_vm.settings.service_titan.active,
                        color: "error",
                        text: ""
                      },
                      on: { click: _vm.deactivateServiceTitan }
                    },
                    [_vm._v(" DEACTIVATE ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.serviceTitanDialog = false
                        }
                      }
                    },
                    [_vm._v(" CANCEL ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.updateSettings }
                    },
                    [_vm._v(" UPDATE ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("confirmation-modal", { ref: "confirm" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }